// Web Storage can be unavailable (private mode, blocked site data) and
// every accessor can throw. Every read/write goes through these wrappers
// so a storage failure degrades to "not remembered", never to a crash.

type Area = "session" | "local";

function area(which: Area): Storage | null {
  try {
    return which === "session" ? window.sessionStorage : window.localStorage;
  } catch {
    return null;
  }
}

export function readStorage(which: Area, key: string): string | null {
  try {
    return area(which)?.getItem(key) ?? null;
  } catch {
    return null;
  }
}

export function writeStorage(which: Area, key: string, value: string): void {
  try {
    area(which)?.setItem(key, value);
  } catch {
    // Not remembered; callers must work without it.
  }
}

export function removeStorage(which: Area, key: string): void {
  try {
    area(which)?.removeItem(key);
  } catch {
    // Nothing to do.
  }
}

export function readJson<T>(which: Area, key: string): T | null {
  const raw = readStorage(which, key);
  if (raw === null) return null;
  try {
    return JSON.parse(raw) as T;
  } catch {
    return null;
  }
}

export function writeJson(which: Area, key: string, value: unknown): void {
  writeStorage(which, key, JSON.stringify(value));
}
